//  Depricated
// ============ 
//  This provider is depricated in favor of getting the customizer collection as part of the original graphql request


import React from "react";

import { useShopQuery } from "@hooks/use-shop-query.js";
import { gql } from "graphql-request";

const queryProducts = gql`
	query ProductAndCollections(
		$country: CountryCode!
		$query: String!
	) @inContext(country: $country) {
		collections(first: 10, query: $query) {
		edges {
			node {
			handle
				products(first: 100) {
					edges {
					node {
						...CustomizerItem
					}
					}
				}
			}
		}
		}
	}

	fragment CustomizerItem on Product {
		title,
		id,
		handle,
		available: availableForSale,
		description,
		title,
		type: productType,
		options{
			id,
			name,
			values
		}
		price: priceRange{
			maxVariantPrice {
				amount
			},
			minVariantPrice {
				amount
			}
		}
		image:featuredImage{
			url,
			altText
		}
		additionalOptions: metafield(namespace:"custom",key:"additional_product_options") {
			value
			references (first:100){
				edges {
					node {
						... on Metaobject {
							id,
							label: field(key:"label"){
								value
							}
							sublabel: field(key:"sublabel"){
								value
							}
							variant: field(key:"variant"){
								reference{
									... on ProductVariant{
										id
										compatibilityKeys: metafield(namespace:"compatibility",key:"keys") {
											value
										}
									}
								}
							}
							compatibility: field(key:"compatibility"){
								value
							}
						}
					}
				}
			}
		}
		usesVehiclePicker: metafield(namespace:"compatibility",key:"uses_vehicle_data") {
			value
		}
		variants(first:100){
			edges{
				node{
					id,
					title,
					sku,
					available: availableForSale,
					options: selectedOptions{
						name,
						value
					}
					price {
						amount
					}
					image {
						url,
						altText
					}
					compatibilityKeys: metafield(namespace:"compatibility",key:"keys") {
						value
					}
				}
			}
		}
	}`

export const ProductCustomizerCollectionContext = React.createContext({
  loading: true
});

export const ProductCustomizerCollectionProvider = ({children, collectionIDs }) => {

	console.warn("The ProductCustomizerCollectionContext is depricated and should be replaced by using a single graphql request in the ProductCustomizerVariantContext")

  	const variables = {
		query: collectionIDs.map(h => `id:${h}`).join(' OR '),
		country: Shopify.country 
	}
  	const {data, loading, error} = useShopQuery(queryProducts, variables);

	const collection = data?.compatibleCollection?.products

  	return <ProductCustomizerCollectionContext.Provider value={{ loading, collection }}>
    	{children}
    </ProductCustomizerCollectionContext.Provider>;
}
